<template>
  <div class="tolerance-page">
    <div class="container">
      <h1 class="page-title">Sheet Metal Capabilities</h1>

      <div class="tolerance-table-wrapper">
        <table class="tolerance-table">
          <tbody>
            <tr>
              <th>Feature</th>
              <th>Description</th>
            </tr>
            <tr>
              <td>Maximum Length</td>
              <td>800mm</td>
            </tr>
            <tr>
              <td>Sheet Thickness</td>
              <td>0.5 / 0.8 / 1.0 / 1.2 / 1.5 / 2.0 / 2.5 / 3.0 / 4.0 / 5.0 / 6.0mm</td>
            </tr>
            <tr>
              <td>General Tolerances</td>
              <td>± 0.2mm</td>
            </tr>
            <tr>
              <td>Cutting Tolerances</td>
              <td>± 0.1mm</td>
            </tr>
            <tr>
              <td>Bending Tolerances</td>
              <td>± 0.3mm</td>
            </tr>
            <tr>
              <td>Bend angle Tolerances</td>
              <td>± 1.0°</td>
            </tr>
            <tr>
              <td>Punching Tolerances</td>
              <td>± 0.1mm</td>
            </tr>
          </tbody>
        </table>
      </div>
      
      <div class="button-wrapper">
        <button class="getQuote-btn" @click="$router.push('/quote')">Get Instant Quote</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Sheet_Capabilities'
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

.tolerance-page {
  padding: 40px 20px;
  background-color: #ffffff;
}

.container {
  max-width: 1000px;
  margin: 0 auto;
  text-align: center;
  display: flex;
  flex-direction: column;
}

/* 标题样式 */
.page-title {
  font-size: 36px;
  color: #333333;
  margin: 0 0 30px;
  font-weight: 600;
}

/* 这里的 overflow-x: auto 是实现滑动的关键 */
.tolerance-table-wrapper {
  width: 100%;
  margin-bottom: 30px;
  overflow-x: auto;
  /* 隐藏移动端的默认滚动条(可选，会让界面更干净，但保留滑动功能) */
  -webkit-overflow-scrolling: touch; 
}

.tolerance-table {
  width: 100%;
  border-collapse: collapse;
  background-color: #ffffff;
  table-layout: fixed;
}

.tolerance-table thead tr {
  background-color: #f0f4f5;
}

.tolerance-table th,
.tolerance-table td {
  padding: 20px 15px;
  text-align: center;
  border: 1px solid #e5e7eb;
  color: #333333;
  font-size: 16px;
  line-height: 1.5;
}

.tolerance-table th {
  background-color: #f0f4f5;
  font-weight: 700;
}

.tolerance-table td:first-child {
  font-weight: 500;
}

/* PC端列宽设定 */
.tolerance-table th:first-child,
.tolerance-table td:first-child {
  width: 25%; 
}

.tolerance-table th:last-child,
.tolerance-table td:last-child {
  width: 75%;
}

/* 按钮容器 */
.button-wrapper {
  display: flex;
  justify-content: center;
}

.getQuote-btn {
  background-color: #16bc9c;
  color: #ffffff;
  border: none;
  padding: 14px 30px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 4px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.getQuote-btn:hover {
  background-color: #13a88b;
}

/* ================= 移动端专属适配（改为滑动模式） ================= */
@media (max-width: 768px) {
  .tolerance-page {
    padding: 30px 15px; 
  }

  .page-title {
    font-size: 26px; 
    margin-bottom: 20px;
  }

  /* 核心修改：设置表格的最小宽度，防止在小屏幕上被强行挤压 */
  .tolerance-table {
    min-width: 600px; /* 宽度低于 600px 时，停止压缩，触发 wrapper 的滑动 */
  }

  .tolerance-table th,
  .tolerance-table td {
    padding: 12px 10px;
    font-size: 14px;
    word-break: normal; /* 取消之前的强制换行，让内容自然舒展 */
  }

  /* 可以重新调整一下比例，让左侧 Feature 稍微宽一点 */
  .tolerance-table th:first-child,
  .tolerance-table td:first-child {
    width: 35%; 
  }

  .tolerance-table th:last-child,
  .tolerance-table td:last-child {
    width: 65%;
  }

  .getQuote-btn {
    width: 100%; 
    max-width: 300px; 
  }
}
</style>